import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileLines } from "@fortawesome/free-solid-svg-icons";
import useTranslation from "../../../../hooks/useTranslation";

interface Props {
    numPages: number;
}

export default function PageIndicator({ numPages }: Props) {
    const { t } = useTranslation();

    return (
        <div
            title={t("pdf_viewer.num_pages", { smart_count: numPages })}
            className="pointer-events-auto absolute bottom-4 left-1/2 z-10 flex -translate-x-1/2 items-center gap-1.5 rounded-full border border-border bg-surface/95 px-3 py-1 text-xs text-ink shadow-md backdrop-blur"
        >
            <FontAwesomeIcon icon={faFileLines} className="text-ink-muted" />
            <span>{numPages}</span>
        </div>
    );
}
